/**
 * Deep C: two long slime floors carry the cave above them. Dig under a floor and whatever rests
 * on it drips through, one scan in eight: diamonds, and boulders too (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepC: CaveDef = {
  id: 'C',
  name: 'SEEP',
  hint: 'Dig under the slime and let the diamonds come to you.',
  intermission: false,
  colors: [4, 13, 3],
  diamondValue: 16,
  extraValue: 24,
  fill: { base: '.', items: [['r', 11], ['d', 5]] },
  levels: [
    { seed: 5301, diamonds: 14, time: 150 },
    { seed: 5302, diamonds: 16, time: 140 },
    { seed: 5303, diamonds: 18, time: 130 },
    { seed: 5304, diamonds: 20, time: 125 },
    { seed: 5305, diamonds: 22, time: 115 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.....?????????????????????????????????W',
    'W..P..?????????????????????????????????W',
    'W.....?????????????????????????????????W',
    'W???????wwwwwwwwww?????????????????????W',
    'W???????wdrddrdrdw?????????????????????W',
    'W???????wrdrdrddrw?????????????????????W',
    'Wsssssssssssssssssssssssss?????????????W',
    'W???????   ????????????????????????????W',
    'W???????   ????????????????????????????W',
    'W??????????????????????????????????????W',
    'W????????????????????????wwwwwwwwww????W',
    'W????????????????????????wrddrdrdrw????W',
    'W????????????????????????wdrdrddrdw????W',
    'W????????????ssssssssssssssssssssssssssW',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W.X????????????????????????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
